import {
	FAVOURITE_BUTTON_SEGMENT_KEY,
	createPageSegmentLoadMetric,
} from '@confluence/browser-metrics';

export const FAVOURITE_BUTTON_METRIC = createPageSegmentLoadMetric({
	key: FAVOURITE_BUTTON_SEGMENT_KEY,
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});
